import axios from 'axios';
import _ from 'lodash';
import {push} from 'connected-react-router';
import {SubmissionError, change, touch} from 'redux-form';
import {
    DOUBLE_CONSENT_AGREE,
    DOUBLE_CONSENT_HIDE,
    DOUBLE_CONSENT_SHOW
} from './TermsPageConstants';
import setUrl from '../../../framework/App/SetUrl';
import {NETWORK, FORM_ID} from '../../../framework/App/AppConstants';
import {PAGE_NAME} from '../../config/pageNames';
import {SUBMIT_API} from '../../config/apiEndpoints';
import {setServerData} from '../../../framework/store/ServerData/ServerDataActions';
import {spinnerClose} from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { buildCapeTxnRunner } from '../../../framework/App/CapeTransaction';
import { handleServerSideErrors } from '../../utils/USUtils';
import { uniqueTimestampId } from '../../../framework/App/AppUtils';
const runUsApplyCapeTxn = buildCapeTxnRunner('us_apply');

export const doubleConsentShow = () => ({
    type: DOUBLE_CONSENT_SHOW
});

export const doubleConsentClose = () => ({
    type: DOUBLE_CONSENT_HIDE
});

export const doubleConsentAgree = () => ({
    type: DOUBLE_CONSENT_AGREE
});

export const handleRedirect = response => {
    if (response && _.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect);
        return true;
    }
    return false;
};

export const submitApplicationApi = data => (dispatch, getState) => {
    return runUsApplyCapeTxn(() => {
        data.clientRequestId = uniqueTimestampId();
        const {serverData = {}} = getState();
        const {_csrf = ''} = serverData;

        return axios
            .request({
                url: SUBMIT_API,
                method: 'post',
                headers: {
                    ...NETWORK.REQUEST.XHR.HEADER,
                    'X-CSRF-Token': _csrf
                },
                data
            })
            .then(async(response) => {
                // handle server-side errors
                await handleServerSideErrors(dispatch, getState, response);
                //If there are any validation errors we want to send user back to page with error
                if (_.get(response, 'data.validationErrors')) {
                    const pageName = _.get(response, 'data.pageName');
                    const validationErrors = _.get(response, 'data.validationErrors');
                    capeLog && capeLog(`response:Validation error on :${pageName}`);

                    dispatch(setServerData({validationErrorModel: validationErrors}));
                    dispatch(doubleConsentClose());
                    for (const validationError of validationErrors) {
                        dispatch(change(FORM_ID, validationError.field, ''));
                        dispatch(touch(FORM_ID, validationError.field));
                    }
                    dispatch(push(pageName));
                    dispatch(spinnerClose());
                } else if (_.get(response, 'data.workflowId')) {
                    dispatch(setServerData({
                        appPendData: {
                            ...response.data
                        }
                    }));
                    dispatch(push(PAGE_NAME.APP_PEND_PAGE));
                    dispatch(spinnerClose());
                } else if (handleRedirect(response)) {
                    return;
                } else {
                    dispatch(setServerData({
                        decisionModel: response.data,
                        userLoggedIn: _.get(response, 'data.userLoggedIn')
                    }));

                    dispatch(push(PAGE_NAME.DECISION_PAGE));
                    dispatch(spinnerClose());
                }
            })
            .catch(error => {
                // show server-side errors on form
                if (error instanceof SubmissionError) {
                    dispatch(doubleConsentClose());
                    return Promise.reject(error);
                }
                capeLog && capeLog('response:error, TermsPageActions,' + (error && error.message));

                if (handleRedirect(error && error.response)) {
                    return;
                }

                if (_.get(error, 'response.data.err', false)) {
                    dispatch(setServerData({errorModel: _.get(error, 'response.data', {})}));
                    dispatch(push(PAGE_NAME.ERROR_PAGE));
                    dispatch(spinnerClose());
                } else {
                    // should never be here
                    capeLog && capeLog('response:error: unexpected error response for TermsPage submit');
                    setUrl(window, PAGE_NAME.ERROR_PAGE);
                }
            });
    });
};

export const overrideTermsStyles = () => {
    const css = '.ppcTerms-position { width: 100% !important; max-width: 100% !important; margin: 0 !important; padding: 0 0.35rem !important; box-sizing: border-box; }';
    const iframe = document.getElementById('terms-and-conditions-iframe');

    if (_.get(iframe, 'contentWindow.document.head')) {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        iframe.contentWindow.document.head.appendChild(style);
    }
};
